module.exports = __webpack_public_path__ + "media/images/networking-064129673c1ecbccfff8fa67b2d6746c.jpg";